<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2023-06-15 11:42:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-08 11:16:59
-->
<template>
  <div
    class="page_container"
    :style="{
      'background-color': pageConfig.bgColor,
      backgroundImage: pageConfig.bgImg ? 'url(' + pageConfig.bgImg + ')' : '',
    }"
  >
    <div v-if="isDevelopment" class="dev-mock-btns">
      <van-button
        size="mini"
        :type="mockUseBlackGoldenUI ? 'warning' : 'primary'"
        round
        @click="toggleMockUiVersion"
      >
        模拟UI：{{ mockUseBlackGoldenUI ? "黑金" : "普通" }}
        (UseBlackGoldenUI={{ mockUseBlackGoldenUI ? 1 : 0 }})
      </van-button>
      <van-button
        v-if="mockUseBlackGoldenUI"
        size="mini"
        type="warning"
        round
        @click="toggleBlackUiVersion"
      >
        黑金主题：v{{ mockBlackUiVersion }}
        (BlackGoldenUIVersion={{ mockBlackUiVersion }})
      </van-button>
      <van-button
        v-if="mockUseBlackGoldenUI"
        size="mini"
        type="info"
        round
        @click="enterBlackMicropoint"
      >
        进入黑金点餐页
      </van-button>
      <van-button
        size="mini"
        type="info"
        round
        @click="
          $router.push({
            name: 'Micropoint',
            query: mockOrderQuery,
          })
        "
        >先进点餐页面，后扫餐台码</van-button
      >
      <van-button
        size="mini"
        type="info"
        round
        @click="
          $router.push(
            `/scanCode/takeNumberResult?action=takeorder&vpncode=${mockOrderQuery.saasCode}&diningRoomId=${mockOrderQuery.diningRoomId}&tablecode=220720`
          )
        "
        >模拟普通点餐</van-button
      >
      <van-button
        size="mini"
        type="info"
        round
        @click="
          $router.push(
            '/scanCode/takeNumberResult?action=takeorder&p=QHCNCD,abc,838821,20000001,8001,01,1450'
          )
        "
        >模拟扫手牌绑定器点餐</van-button
      >
    </div>
    <div class="f-1">
      <!-- <select-store-entrance @sendVpnId="sendVpnId"></select-store-entrance> -->
      <!-- 动态组件 -->
      <component
        :is="item.component"
        v-for="(item, index) in pageComponents"
        :key="index"
        :datas="item.setStyle"
        class="components_class"
      >
      </component>
    </div>

    <button
      v-if="mPermissionCheck"
      class="report-float-button"
      type="button"
      aria-label="打开报表"
      @click="handleToPage('ReportLogin')"
    >报表</button>

    <myFooter></myFooter>

  </div>
</template>

<script>
// import { pageModuleArr, pageConfig } from "@/utils/testJson";
import { getWetWechatCustomPage } from "@/api/member";
import wxConfig from "@/utils/wxConfig.js";
import myFooter from "@/components/myFooter";
import { checkPermissionCheck } from "@/api/login";
import {
  getDevMockBlackGoldenUIVersion,
  getDevMockUseBlackGoldenUI,
  setDevMockBlackGoldenUIVersion,
  setDevMockUseBlackGoldenUI,
} from "@/utils";
import { Toast } from "vant";
export default {
  name: "CustomHomePage",
  props: {},

  components: { myFooter },
  data() {
    return {
      pageComponents: [],
      pageConfig: {},
      pageType:1,
      mPermissionCheck:false,
      isDevelopment: process.env.NODE_ENV === "development",
      mockUseBlackGoldenUI: false,
      mockBlackUiVersion: 1,
      mockOrderQuery: {
        saasCode: "db022a15-c9a3-4206-8ad9-09a3273a5078",
        diningRoomId: "299792459",
      },
    };
  },

  created() {
    if (this.isDevelopment) {
      const mock = getDevMockUseBlackGoldenUI();
      this.mockUseBlackGoldenUI = mock === 1;
      const version = getDevMockBlackGoldenUIVersion();
      this.mockBlackUiVersion = version || 1;
    }
  },
  watch: {
    "$route.query.page"(val) {
      this.pageType = val;
      this.handleGetWetWechatCustomPageConfig();
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log("to===", to.name);
  //   console.log("from.name ===", from.name);
  //   console.log("from ===", from);
  //   next((vm) => {
  //     if (vm.$route.query.page == 1) {
  //       vm.$route.meta.title = "首页";
  //     } else if (vm.$route.query.page == 2) {
  //       vm.$route.meta.title = "个人中心";
  //     }
  //   });
  // },
  mounted() {
    // 重定向之前的原页面路径
    this.mPermissionCheck = false;
    this.pageOriginUrl = this.$route.redirectedFrom;
    this.pageType = this.$route.query.page || 1;
    this.handleGetWetWechatCustomPageConfig();
    this.handcheckPermissionCheck()
    // this.pageComponents = pageModuleArr;
    console.log("this.pageType===== "+this.pageType);
  },
  updated() {},
  methods: {
    /**
     * 开发环境切换本地模拟 UseBlackGoldenUI。
     * 下次拉 vpn 接口后会按该参数改写返回值。
     */
    toggleMockUiVersion() {
      if (!this.isDevelopment) return;
      this.mockUseBlackGoldenUI = !this.mockUseBlackGoldenUI;
      setDevMockUseBlackGoldenUI(this.mockUseBlackGoldenUI ? 1 : 0);
      if (this.mockUseBlackGoldenUI) {
        setDevMockBlackGoldenUIVersion(this.mockBlackUiVersion || 1);
      }
      Toast(
        `已设置模拟 UseBlackGoldenUI=${this.mockUseBlackGoldenUI ? 1 : 0}，重新进入点餐流程后生效`
      );
    },
    /** 开发环境切换黑金子主题 v1 / v2（Figma） */
    toggleBlackUiVersion() {
      if (!this.isDevelopment || !this.mockUseBlackGoldenUI) return;
      this.mockBlackUiVersion = this.mockBlackUiVersion === 2 ? 1 : 2;
      setDevMockUseBlackGoldenUI(1);
      setDevMockBlackGoldenUIVersion(this.mockBlackUiVersion);
      Toast(
        `已设置黑金主题 v${this.mockBlackUiVersion}（BlackGoldenUIVersion=${this.mockBlackUiVersion}）`
      );
    },
    enterBlackMicropoint() {
      if (!this.isDevelopment) return;
      setDevMockUseBlackGoldenUI(1);
      setDevMockBlackGoldenUIVersion(this.mockBlackUiVersion || 1);
      const pageName =
        this.mockBlackUiVersion === 2 ? "BlackMicropointV2" : "BlackMicropoint";
      this.$router.push({
        name: pageName,
        query: {
          ...this.mockOrderQuery,
          blackUiVersion: this.mockBlackUiVersion || 1,
        },
      });
    },
    handleGetWetWechatCustomPageConfig() {
      getWetWechatCustomPage({
        VpnNumber: this.$store.state.vpnNumber,
        Page: this.pageType,
      }).then((res) => {
        if (res) {
          const configData = res[0];
          if (configData.Info) {
            this.pageConfig = JSON.parse(configData.Info);
            if (this.pageConfig.shareTitle) {
              // 分享时拼接 重定向之前的原页面路径
              const pageBaseUrl = location.href.split("#")[0];
              wxConfig.WeChatShare(
                this,
                pageBaseUrl + "#" + this.pageOriginUrl,
                this.pageConfig.shareTitle,
                this.pageConfig.shareImg,
                this.pageConfig.shareDetails
              );
            }
            // this.$route.meta.title = this.pageConfig.name;
          }
          // if (res.Info) {
          // this.pageConfig = JSON.parse(res.Info);
          // if (this.pageConfig.shareTitle) {
          //   wxConfig.WeChatShare(
          //     this,
          //     location.href,
          //     this.pageConfig.shareTitle,
          //     this.pageConfig.shareImg,
          //     this.pageConfig.shareDetails
          //   );
          // }
          // }
          if (configData.Body) {
            this.pageComponents = JSON.parse(configData.Body);
          } else {
            this.pageComponents = [];
          }
        } else {
             this.pageComponents = [];
        }
      });
    },

    /**检查报表权限**/
    handcheckPermissionCheck(){
      checkPermissionCheck().then(res=>{
        console.log("checkPermissionCheck==== "+res)
         if(res===true&&this.pageType==2){
            this.mPermissionCheck = true
         }else {
            this.mPermissionCheck = false
         }
      })
    },
    handleToPage(page){
       this.$router.push({ name: page });
    }

    // sendVpnId(val) {
    //   this.vpnId = val;
    // },
  },
};
</script>
<style scoped lang="scss">
.page_container {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: calc(100px + env(safe-area-inset-bottom));
  min-height: calc(100vh - 100px - env(safe-area-inset-bottom));
}
.dev-mock-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px;
  position: relative;
  z-index: 2;
}
.components_class {
  // margin: 10px 0;
  overflow: hidden;
}
.report-float-button {
  position: fixed;
  right: 30px;
  bottom: calc(150px + env(safe-area-inset-bottom));
  z-index: 3;
  width: 96px;
  height: 96px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #8c8c8c80;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
  color: #fff;
  font-size: 24px;
  line-height: 96px;
  text-align: center;
}

.report-float-button:active {
  background: #8c8c8c80;
}
</style>
